module.exports = __webpack_public_path__ + "img/service.fe65957b.png";